import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import StartPage from "./components/StartPage";
import TableSelection from "./components/TableSelection";
import IngredientSelection from "./components/IngredientSelection";
import FinalOutcome from "./components/FinalOutcome";
import ParticleBackground from "./components/ParticleBackground";
import "./App.css";

function App() {
  const [gameState, setGameState] = useState("start");
  const [selectedTable, setSelectedTable] = useState(null);
  const [selectedIngredients, setSelectedIngredients] = useState([]);

  const nextStage = () => {
    setGameState((prevState) => {
      switch (prevState) {
        case "start":
          return "tableSelection";
        case "tableSelection":
          return "ingredientSelection";
        case "ingredientSelection":
          return "finalOutcome";
        default:
          return "start";
      }
    });
  };

  const goBack = () => {
    setGameState((prevState) => {
      switch (prevState) {
        case "tableSelection":
          return "start";
        case "ingredientSelection":
          return "tableSelection";
        case "finalOutcome":
          return "ingredientSelection";
        default:
          return "start";
      }
    });
  };

  useEffect(() => {
    if (
      gameState === "finalOutcome" &&
      (!selectedTable || selectedIngredients.length === 0)
    ) {
      setGameState("ingredientSelection");
    }
  }, [gameState, selectedTable, selectedIngredients]);

  return (
    <Router>
      <div className="app-container">
        <ParticleBackground />
        <div className="content-container">
          {gameState === "start" && <StartPage onStart={nextStage} />}
          {gameState === "tableSelection" && (
            <TableSelection
              onSelect={(table) => {
                setSelectedTable(table);
                nextStage();
              }}
              onGoBack={goBack}
            />
          )}
          {gameState === "ingredientSelection" && (
            <IngredientSelection
              selectedTable={selectedTable}
              onSelect={(ingredients) => {
                setSelectedIngredients(ingredients);
                nextStage();
              }}
              onGoBack={goBack}
            />
          )}
          {gameState === "finalOutcome" &&
            selectedTable &&
            selectedIngredients.length > 0 && (
              <FinalOutcome
                selectedTable={selectedTable}
                selectedIngredients={selectedIngredients}
                onGoBack={() => {
                  setGameState("start");
                  setSelectedTable(null);
                  setSelectedIngredients([]);
                }}
              />
            )}
        </div>
      </div>
    </Router>
  );
}

export default App;
